import { render, staticRenderFns } from "./CheckoutBillingPaymentMethod.vue?vue&type=template&id=5b29aedf&"
import script from "./CheckoutBillingPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./CheckoutBillingPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports